import { atomWithStorage } from 'jotai/utils';
import { atomFamily } from 'jotai-family';
// I den här filen skapas inställningar (med hjälp av jotai) för inställningar som ska sparas i ett globalt state.
// Det kan vara inställningar som inte ska återställas när en komponent skapas. Det kan finnas prestandavinster på att flytta hit inställningar som nu ligger i en komponent
// högt upp i komponentträdet.
export interface IColumnSettings {
  width: number;
}

export interface IColumnsSettings {
  [key: string]: IColumnSettings;
}

/** Inställningar för kolumner som sparas per klient.  */
export const GlobalColumnSettings = atomFamily((id: string) =>
  atomWithStorage(`GlobalColumnSettings-${id}`, {} as IColumnsSettings)
);
